const style = {
    main: "gruppo pb-14",
    header: "w-full text-center text-2xl font-semibold",
}

export default style